import { render, staticRenderFns } from "./userwisefinince_dashboard.vue?vue&type=template&id=4078551b"
import script from "./userwisefinince_dashboard.vue?vue&type=script&lang=js"
export * from "./userwisefinince_dashboard.vue?vue&type=script&lang=js"
import style0 from "./userwisefinince_dashboard.vue?vue&type=style&index=0&id=4078551b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports